export default __webpack_public_path__ + "static/card-7-1de14ed3d5f852395d97ca4f3f23e4d4.png";